import { Link } from 'react-router-dom';
import { useLocale } from '../hooks/useLocale';

export default function PrivacyPage() {
  const { t } = useLocale();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <header className="bg-white dark:bg-gray-800 shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between">
          <h1 className="text-xl font-bold text-primary-600">
            {t('app_name')}
          </h1>
          <Link
            to="/"
            className="text-sm text-primary-500 hover:underline"
          >
            {t('get_started')}
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold mb-8">{t('privacy')}</h1>

        <div className="prose dark:prose-invert max-w-none space-y-6 text-gray-700 dark:text-gray-300">
          <section>
            <h2 className="text-xl font-semibold mb-3">
              Information We Collect
            </h2>
            <p>
              When you sign in with Google, we receive your email address,
              name, and profile picture. This information is used only to
              create and manage your account.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              How We Use Your Information
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>To provide and maintain our service</li>
              <li>To manage your subscription</li>
              <li>To send service-related notifications</li>
              <li>To improve our application</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Data Storage</h2>
            <p>
              Your data is stored securely in Cloudflare D1 database. We
              implement industry-standard security measures to protect your
              personal information.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Third-Party Services</h2>
            <p>
              We use Google OAuth for authentication. Google's privacy policy
              applies to the initial authentication step. We use Paymento for
              payment processing — they handle all payment data.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Contact</h2>
            <p>
              If you have questions about this privacy policy, please contact
              us at support@langbook-reader.app.
            </p>
          </section>

          <p className="text-sm text-gray-500 mt-8">
            Last updated: July 2026
          </p>
        </div>
      </main>
    </div>
  );
}
